import React from 'react';
import NumberFormat from 'react-number-format';
import * as PropTypes from 'prop-types';

function NumberFormatBalance(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.floatValue,
                    },
                });
            }}
            thousandSeparator=" "
            allowNegative={true}
            decimalSeparator=","
            isNumericString
        />
    );
}

NumberFormatBalance.propTypes = {
    inputRef: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default NumberFormatBalance;